import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import GenericListPair from 'modules/common/components/GenericListPair';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import useDebounce from 'modules/common/components/UseDebounce';

import * as actions from '../action';
import * as c from '../constant';

import SystemModulesContent from './SystemModulesContent';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';

const form = {
  keyword: '',
};

function SystemModulesContainer({
  match,
  history,
  getRequirementList,
  requirementList,
  requirementListPager,
  isLoading,
  removeRequirement,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add System Module',
      modalSize: 'modal-xl',
    });
  };

  const handleEdit = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update System Module',
      modalSize: 'modal-xl',
    });
  };

  const handleRemove = data => e => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this how to?',
      () => {
        removeRequirement(data.id, () => {
          getRequirementList();
          const id = _.get(requirementList, '0.id');
          history.push(`/general-settings/how-to/main/${id}`);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getRequirementList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);
  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getRequirementList({ name: formData.keyword });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:requirementId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Menu List"
            getData={getRequirementList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search menu..."
            pathName={`${match.path}/:requirementId?`}
            listName="Title List"
            label="How To's List"
            renderItem={item => (
              <div className="px-3 py-3">
                {_.get(item, 'attributes.title_en')}
              </div>
            )}
            isLoading={isLoading}
            selected={params.requirementId}
            data={requirementList}
            dataPager={requirementListPager}
            handleSelectRow={data => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:requirementId?`}
                    render={() => (
                      <SystemModulesContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:requirementId?`}
                  render={() =>
                    !params.requirementId && requirementList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(requirementList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

SystemModulesContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getRequirementList: PropTypes.instanceOf(Function).isRequired,
  requirementList: PropTypes.instanceOf(Array).isRequired,
  requirementListPager: PropTypes.instanceOf(Object).isRequired,
  removeRequirement: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  requirementList: _.get(api, `${c.GET_REQUIREMENT}.list`) || [],
  requirementListPager: _.get(api, `${c.GET_REQUIREMENT}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_REQUIREMENT) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(SystemModulesContainer);
